import { HttpClient } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AuthService } from 'app/core/authentication/authentication.service';
import { OPTIONS } from 'app/core/library';
import { PrivateService } from 'app/core/services/private.service';
import { Login } from 'app/shared/models/login';
import { Base64 } from 'js-base64';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'dialog-remitt-sso',
  templateUrl: './dialog-remitt-sso.component.html',
  styleUrls: ['./dialog-remitt-sso.component.scss']
})
export class DialogRemittSsoComponent implements OnInit {

  account: Login = <Login>{};
  hide = true;
  isLoading = false;
  loginForm: FormGroup;
  isAccountLoading = false;
  active = false;
  username: any;
  password: any;
  OTP: any;
  countdown: number = 300;
  countdownInterval: any;
  showRegenBtn = false;

  constructor(public dialogRef: MatDialogRef<DialogRemittSsoComponent>, @Inject(MAT_DIALOG_DATA) public data: any,
    private privateService: PrivateService, public authService: AuthService, private http: HttpClient,
    private toastr: ToastrService, private fb: FormBuilder) {
    this.loginForm = this.fb.group({
      RAMP_username: [''],
      Password: ['']
    });
  }

  ngOnInit(): void {
    this.isAccountLoading = true;
    this.getConnectedAccount();
  }

  getConnectedAccount() {
    this.privateService.getConnectedAccounts().subscribe({
      next: res => {
        if (res.length > 0) {
          this.loginForm.patchValue({
            RAMP_username: res[0].RAMP_username,
            Password: res[0].Password
          });
          this.username = res[0].RAMP_username;
          this.password = res[0].Password;

          this.active = true;
          this.isAccountLoading = false;
          this.loginForm.controls['RAMP_username'].disable();
          this.loginForm.controls['Password'].disable();
          this.remittLoginOTP(this.username, this.password);
        } else {
          this.active = false;
          this.isAccountLoading = false;
        }
      },
      error: err => {
        console.log(err);
        this.isAccountLoading = false;
      }
    });
  }

  verifyDevice() {
    if (this.isLoading) {
      return; // Prevent multiple submissions
    }
    
    this.isLoading = true;
    const { RAMP_username, Password } = this.loginForm.value;
    this.remittLogin(RAMP_username, Password);
  }
  
  logoutAccount(username: string) {
    this.isLoading = true;
    this.privateService.deleteConnectedAccount(username).subscribe({
      next: res => {
        this.isLoading = false;
        this.active = false;
        this.loginForm.patchValue({
          RAMP_username: '',
          Password: ''
        });
        this.username = '';
        this.password = '';
        this.loginForm.controls['RAMP_username'].enable();
        this.loginForm.controls['Password'].enable();
      },
      error: err => {
        this.isLoading = false;
        console.log(err);
      }
    })
  }

  hidePassword(): void {
    this.hide = !this.hide;
  }

  remittLoginOTP(username: string, password: string) {
    this.isLoading = true;
    this.http.post<any>(`https://idempiere.threetwojuan.com/services/api/auth/sso_login`, { username, password })
      .subscribe({
        next: res => {
          this.OTP = res;
          this.startCountdown(300); // Start a 5-minute countdown (300 seconds)
          this.isLoading = false;
        },
        error: err => {
          const text = 'User not found.';
          this.showNotification(text);
          this.isLoading = false;
        }
      });
  }

  startCountdown(seconds: number) {
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval); // Clear any existing intervals
    }
  
    this.countdown = seconds;
    this.countdownInterval = setInterval(() => {
      this.countdown--;
  
      if (this.countdown <= 0) {
        clearInterval(this.countdownInterval);
        this.OTP = ''; // Clear the OTP after expiration
        this.showRegenBtn = true; // Show the "Regenerate" button
      }
    }, 1000); // Update every second
  }

  formatCountdown(): string {
    const minutes = Math.floor(this.countdown / 60);
    const seconds = this.countdown % 60;
    return `${minutes < 10 ? '0' : ''}${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
  }

  regenerateOTP() {
    this.remittLoginOTP(this.username, this.password);
  }

  remittLogin(username: string, password: string) {
    this.isLoading = true;
    this.http.post<any>(`https://idempiere.threetwojuan.com/services/api/auth/verify_login`, { username, password })
      .subscribe({
        next: res => {
          this.insertConnectedAccount(username, password);
        },
        error: err => {
          const text = 'User not found.'
          this.showNotification(text);
          this.isLoading = false;
        }
      });
  }

  insertConnectedAccount(username: string, password: string) {
    this.privateService.insertConnectedAccounts(username, password).subscribe({
      next: res => {
        this.isLoading = false;
        this.getConnectedAccount();
        this.active = true;
      },
      error: err => {
        console.log(err);
        this.isLoading = false;
      }
    });
  }

  showNotification(text) {
    this.toastr.success('<span class="now-ui-icons ui-1_bell-53"></span> ' + text + '', '', {
      timeOut: 3000,
      closeButton: true,
      enableHtml: true,
      toastClass: "alert alert-danger alert-with-icon",
      positionClass: 'toast-' + 'top' + '-' + 'center'
    });
  }

  onNoClick() {
    this.dialogRef.close();
  }

  onClick() {
    this.dialogRef.close();
  }

  getDynamicUrl(): string {
    const userId = this.username;
    const access = this.password;
    const otp = this.OTP;
    const userIdParam = Base64.encode(userId).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
    const accessParam = Base64.encode(access).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
    const otpParam = Base64.encode(otp).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');

    if (userId && access) {
      return `https://portal.threetwojuan.com/#/auth/${accessParam}/${userIdParam}/${otpParam}`;
    } else {
      return `https://portal.threetwojuan.com/#/login`;
    }
  }
}
